module.exports = __webpack_public_path__ + "static/media/3.9df2e91d.webp";